import React from 'react'
import { alignSingleBarLeft, hideBarPadLabel, CHART_PALETTE, CHART_TITLE_STYLE } from "../HelperFunction/helperFunction";
import Chart from "react-apexcharts";
import { useOutletContext } from 'react-router-dom';
import ExceptionVariables from '../JSON Files/ExceptionVariables';

function SingleBarChart8({fulldataset,type,isValue,range,maxValuedynamicVolume,labelHeight}) {
  const { theme } = useOutletContext();
  const isDark = theme !== 'light';
  let hidevar = ExceptionVariables.hiddenroichart;
  const filtered = fulldataset?.plot13?.filter(varObj => varObj?.attribute_value_per_roi > 0 && !hidevar?.includes(varObj?.variable));
  const isStacked = filtered?.some(item => item.frequency);
  let maxValue=isStacked?3*maxValuedynamicVolume:maxValuedynamicVolume
  
  
  const groupedData = {};
  if (isStacked) {
    // fulldataset?.plot13?.forEach(item => {
    filtered?.forEach(item => {
      if (!groupedData[item.variable]) {
        groupedData[item.variable] = [];
      }
      groupedData[item.variable].push({ x: item.frequency, y: item.attribute_value_per_roi.toFixed(3) });
    });
  }

  let categories = isStacked
    ? [...new Set(filtered?.map((item) => item.frequency))]
    : (filtered?.map((item) => item.variable) || []);
  let series = isStacked
    ? Object.keys(groupedData).map((variable) => ({
        name: variable,
        data: groupedData[variable],
      }))
    : [{
        name: "ROI",
        data: filtered?.map((it) => Number(it?.attribute_value_per_roi?.toFixed(3))),
      }];
  ({ categories, series } = alignSingleBarLeft(categories, series));
  const barColumnWidth = `${Math.min(70, Math.max(categories.length || 1, 1) * 11)}%`;

  const options={
    chart: {
      id: `Download-ROI for Media Variables`,
      type: isStacked ? "bar" : "bar",
      stacked: isStacked,
      toolbar: { show: true },
      background: 'transparent',
    },
    grid: { show: false },
    tooltip: {
      theme: isDark ? 'dark' : 'light',
    },
    title: {
      text: `ROI for Media Variables (${type})`,
      align: 'center',
      style: CHART_TITLE_STYLE,
    },
    colors: CHART_PALETTE,
    plotOptions: { bar: { columnWidth: barColumnWidth, dataLabels: { position: "top" } } },
    dataLabels: {
      enabled: isStacked?false:true,
      offsetY: -15,
      style: { fontFamily: "'JetBrains Mono', 'Inter', monospace", fontSize: "12px", fontWeight: 600 },
      formatter: (val) => (val == null ? "" : Number(val).toFixed(3)),
    },
    xaxis: {
      categories: categories.map((item) => {
        if (hideBarPadLabel(item) === "") return item;
        const variable = String(item || "");
        const words = variable.split(/[\s_]+/);
        if (words.length <= 2) return [words.join(" ")];
        return [words.slice(0, 2).join(" "), words.slice(2).join(" ")];
      }),
      title: { text: '', style: { fontWeight: 600, fontSize: "12px" } },
      labels: {
        rotate: -50,
        rotateAlways: true,
        formatter: (val) => hideBarPadLabel(val),
        style: { fontWeight: 500, fontSize: "10px" },
        offsetY: -6,
        ...(labelHeight ? { minHeight: labelHeight, maxHeight: labelHeight } : {}),
      },
    },
    yaxis: [{
      seriesName: 'ROI',
      opposite: false,
      axisBorder: { show: true },
      labels: {
        style: { fontWeight: 500, fontSize: "11px" },
        formatter: (val) => val,
      },
      min: 0,
      max: Math.ceil(maxValue),
    }],
    annotations: {
      yaxis: [{
        y: 0,
        borderColor: '#6C757D',
        label: { text: '', style: { color: '#6C757D', background: '#1A252F' } }
      }]
    }
  };

  return (
    <>
      <div className="rr-chart-period"><small>Time Period: {range}</small></div>
      <div className="rr-chart-yaxis">
        <span className="rr-chart-yaxis-label">ROI</span>
        <div className="rr-chart-yaxis-body">
          <Chart className="rr-apex rr-apex-bar"
            align="center"
            options={options}
            series={series}
            type="bar"
            height={320}
            width={'100%'}
          />
        </div>
      </div>
    </>
  )
}

export default SingleBarChart8;
